/* eslint-disable import/prefer-default-export */

export const RELOAD_REQUESTED = 'RELOAD_REQUESTED';
export const POST_TO_EDIT_CHANGED = 'POST_TO_EDIT_CHANGED';
export const NEW_POST_CHANGED = 'NEW_POST_CHANGED';
export const HAS_POSTS_CHANGED = 'HAS_POSTS_CHANGED';
